"use strict";

import http from "@/http";

const getUsers = async (isDeleted = false) => {
  let endpoint = '/users';
  if (isDeleted) {
    endpoint = endpoint + '/deleted';
  }
  const response = await http.get(endpoint);
  return response.data;
};

const getRoles = async () => {
  const response = await http.get("/roles");
  return response.data;
};

const addUser = async user => {
  const response = await http.post("/users", user);
  return response.data;
};

const updateUser = async user => {
  const response = await http.put(`/users/${user._id}`, user);
  return response.data;
};

const deleteUser = async id => {
    const response = await http.delete(`/users/${id}`);
    return response.data;
};

const isValidEmail = async (id, email) => {
  const response = await http.get(`/users/is-valid-email/${id}/${email}`);
  return response.data;
};

const isValidUsername = async (id, username) => {
  const response = await http.get(`/users/is-valid-username/${id}/${username}`);
  return response.data;
};

const changePassword = async (id, newPassword) => {
  const response = await http.put(`/users/${id}/change-password`, {
    newPassword: newPassword
  });
  return response.data;
};

const getSystemUsers = async () => {
  const response = await http.get("/users/system");
  return response.data;
};

export default {
  getUsers,
  getRoles,
  getSystemUsers,
  addUser,
  updateUser,
  deleteUser,
  isValidEmail,
  isValidUsername,
  changePassword
};
